<template lang="pug">
div
  p.label Documentos validados

  div(v-for="validacao in validacoes", :key="`${validacao.tipo}-${validacao.label}`")
    app-item-despacho-automatizado-valido(:validacao="validacao")
</template>

<script>
import AppItemDespachoAutomatizadoValido from '@/components/AppItemDespachoAutomatizadoValido'
export default {
  components: {
    AppItemDespachoAutomatizadoValido
  },
  props: {
    validacoes: {
      required: true
    }
  }
}
</script>
<style scoped>
.label {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/AppValidacaoAutomatizada.vue